import { SCENE_DIR_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: SCENE_DIR_MNG,
  params: null,
  customParams: {},
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入场景目录名',
    moreBtnWidth: 160,
    searchFieldNameArr: ['sceneDirName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'left',
        label: 'sk.back',
        action: 'ReturnPage'
      },
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'SceneDirCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          type: 'selection',
          width: 55
        }
      },
      {
        props: {
          label: '场景目录',
          prop: 'sceneDirName',
          sortField: 'sceneDirName',
          width: 220
        }
      },
      {
        props: {
          label: '场景目录描述',
          prop: 'sceneDirDesc',
          sortField: 'sceneDirDesc'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'SceneDirEdit',
        name: 'edit'
      }
    ]
  }
}
